export default "__VITE_ASSET__DZUuSABt__"